import { Avatar, Accordion, AccordionDetails, AccordionSummary, Box, Drawer, IconButton, List, ListItem, ListItemText, Menu, MenuItem, Typography, Button} from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import React, { useCallback, useState,useEffect } from 'react';
import { Link, useNavigate, NavLink, useLocation,  } from 'react-router-dom';
import {
    Menu as MenuIcon,
   
  } from "@mui/icons-material";
import LogoutIcon from "@mui/icons-material/Logout";
import Avater from '../../assets/avater.jpg';
import CaretDown from '../../assets/CaretDown.svg';
import MenuOpen from '../../assets/menu-close.svg';
import TrackingSidebar from '../TrackingSidebar/TrackingSidebar';




export default function NavBar() {
  // const [toggledrawer, setToggleDrawer] = useState(false)
  const [trackingSidebar,setTrackingSidebar] = useState(false)
  // eslint-disable-next-line 
  const [openModal, setOpenModal] = useState(false)
  const {pathname} = useLocation();
  const [balance, setBalance] = useState(null);
  const navigate = useNavigate()
    // Single state to manage which menu is open
    const [menuState, setMenuState] = useState({ product: null, avatar: null, drawer: false });

    const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);



  useEffect(() => {
    const storedBalance = sessionStorage.getItem("userBalance");
    if (storedBalance) {
      const parsedBalance = parseFloat(storedBalance);
      setBalance(parsedBalance);
      console.log("User Balance:", parsedBalance); 
    }
  }, []);
  


  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
    const toggleDrawer = useCallback((open) => {
      setMenuState((prev) => ({ ...prev, drawer: open }));
    }, []);
  
   // Use a callback to ensure event handling is correct
   const handleMenuOpen = (type,event) => {
    setMenuState((prev) => ({ ...prev, [type]: event.currentTarget }));
  };

  const handleMenuClose = (type) => {
    setMenuState((prev) => ({ ...prev, [type]: null }));
  };



    const handleTrackingClick = () =>{
      setOpenModal(false)
      setTrackingSidebar(true)
    }

    const handleCloseTrackingSidebar = ()=>{
      setTrackingSidebar(false)
    }
    
    const handleLogout = () => {
      // Clear user session (e.g., localStorage or cookies)
      localStorage.removeItem("authToken"); // Adjust this based on how authentication is handled
      navigate("/");
    };
    



  return (
    <Box sx={{fontFamily: theme=> theme.typography.smallText}}>
       {/* Mobile Menu - Hamburger Icon */}
       <Box sx={{ display: { xs: 'flex', md: 'none' }, alignItems: 'center'}}>
        <IconButton color="blue" onClick={() => toggleDrawer(true)}>
          <MenuIcon sx={{ color: (theme) => theme.palette.secondary.main }} />
        </IconButton>

        {/* Mobile Menu - Drawer */}
        <Drawer
          anchor="right"
          open={menuState.drawer}
          onClose={() => toggleDrawer(false)}
          sx={{
            width: 250,
            flexShrink: 0,
            '& .MuiDrawer-paper': {
              width: 250,
              backgroundColor: '#fff',
              color: '#000',
              height: '100vh',
              borderTopLeftRadius: '25px',
              borderBottomLeftRadius: '25px',
             
      
            },
          }}
        >
          <List sx={{marginBottom:3,  flexGrow: 1,  
      overflowY: 'auto', 
      maxHeight: 'calc(100vh - 50px)', 
      paddingBottom: 3, }}>
           
            <Box sx={{display:'flex', alignItems:'center', justifyContent:'space-between', px:3}}>

                <img src={MenuOpen} alt='menu open' onClick={() => toggleDrawer(false)} style={{cursor:'pointer'}}/>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
        {/* Cart with Badge
        <Box>
          <IconButton color="red" sx={{ mr: 2, '&:hover': { backgroundColor: 'red' } }} onClick={()=>setCartView(!cartview)}>
            <img src={Cart} alt="Shopping Cart" />
          </IconButton>
        </Box> */}


     
      {/* Avatar with Dropdown */}
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 3 }}>
  <IconButton
    onClick={(e) => handleMenuOpen('avatar', e)}
    sx={{
      color: 'inherit',
      position: 'relative',
      padding: 0,
    }}
  >
    <Avatar sx={{ width: 32, height: 32 }}>
      <img src={Avater} alt="Avatar" style={{ width: '100%', height: '100%' }} />
    </Avatar>
  </IconButton>

 
</Box>


     
    
      </Box>
            </Box>
           
              <ListItem button onClick={() => toggleDrawer(false)} sx={{width:'100%',cursor:'pointer', px:0, marginTop:4,   
         }}>
          <Box
  sx={{
    borderBottom: '1px solid #E6D9FE',
    display: 'flex',
    alignItems: 'center', 
    justifyContent: 'center', 
    width: '100%',
    pb: 2, 
    fontFamily: (theme) => theme.typography.smallText,
  }}
>
  {balance !== null && (
    <Typography
      variant="body2"
      sx={{
        fontSize:16,
        fontWeight: 800,
        color: (theme) => theme.palette.primary.main,
        fontFamily: (theme) => theme.typography.smallText,
      }}
    >
      NGN {balance.toLocaleString(undefined, { minimumFractionDigits: 2 })}
    </Typography>
  )}
</Box>

          
            </ListItem>
            <ListItem button  onClick={() => toggleDrawer(false)} sx={{width:'100%', cursor:'pointer',px: 3,   
                  }}>
          <ListItem 
  button 
  onClick={() => toggleDrawer(false)} 
  sx={{
    width: '100%',
    cursor: 'pointer',
    px: 3,
    display: 'flex',
    borderBottom: '1px solid #E6D9FE', // Ensuring border shows up
  
  }}
>
<Link to='/product/giftshop'>
  <ListItemText 
    primary="Giftshop" 
    sx={{
      fontWeight: 400,
      "& span": {
        fontFamily: (theme) => theme.typography.smallText,
      }
    }}
    
  />
  </Link>
</ListItem>

          
            </ListItem>
            <ListItem button  onClick={() => toggleDrawer(false)} sx={{width:'100%', cursor:'pointer', px: 3, 
            
                  }}>
            <Box
                sx={{
                  borderBottom: '1px solid #E6D9FE',
                  display: 'flex',
                  alignItems: 'flex-start',
                  justifyContent: 'flex-start',
                  width:'100%',
              
                }}

              >
                <Link to='/product/digital-courses'>
               
                <ListItemText primary="Digital Courses" sx={{display: 'flex',
                  alignItems: 'flex-start',
                  justifyContent: 'flex-start',   
                  fontWeight: 400,  "& span": {  // Target the span element
                    fontFamily: theme=> theme.typography.smallText, // Change the font family of the span
                  },}}/>
                   </Link>
              </Box>
          
            </ListItem>

            <ListItem button  onClick={() => toggleDrawer(false)} sx={{width:'100%', cursor:'pointer', px: 3,  
   
  }}>
<Box
sx={{
  borderBottom: '1px solid #E6D9FE',
  display: 'flex',
  alignItems: 'flex-start',
  justifyContent: 'flex-start',
  width:'100%',

}}

>
<Link to='/product/marketplace'>

<ListItemText primary=" P2P Marketplace" sx={{display: 'flex',
  alignItems: 'flex-start',
  justifyContent: 'flex-start',   
  fontWeight: 400,  "& span": {  // Target the span element
    fontFamily: theme=> theme.typography.smallText, // Change the font family of the span
  },}}/>
   </Link>
</Box>

</ListItem>
            

            <ListItem button  onClick={() => toggleDrawer(false)} sx={{width:'100%', cursor:'pointer', px: 3, 
            
          }}>
    <Box
        sx={{
          borderBottom: '1px solid #E6D9FE',
          display: 'flex',
          alignItems: 'flex-start',
          justifyContent: 'flex-start',
          width:'100%',
      
        }}

      >
        <Link to='/product/ptwop'>
       
        <ListItemText primary="My P2P Product" sx={{display: 'flex',
          alignItems: 'flex-start',
          justifyContent: 'flex-start',   
          fontWeight: 400,  "& span": {  // Target the span element
            fontFamily: theme=> theme.typography.smallText, // Change the font family of the span
          },}}/>
           </Link>
      </Box>
  
    </ListItem>
   
   


            <ListItem sx={{width:'100%', py:0,borderBottom: '1px solid #E6D9FE', fontFamily: theme=> theme.typography.smallText, fontWeight: 400, cursor:'pointer',px: 3,  
          
                  }}>
            <Accordion sx={{boxShadow:'none'}}>
              <AccordionSummary sx={{p:0}}>My Favourite</AccordionSummary>
              <AccordionDetails sx={{p:0}}>
              <ListItemText onClick={()=> navigate('/product/giftshop/favourite')} primary="Gifts" sx={{display: 'flex',
                  alignItems: 'flex-start',
                  my:2,
                  justifyContent: 'flex-start',  
                  cursor:'pointer', 
                  fontWeight: 400,  "& span": {  // Target the span element
                    fontFamily: theme=> theme.typography.smallText, // Change the font family of the span
                  },}}/>
                  <ListItemText onClick={()=> navigate('/product/digital-courses/favourite')} primary="Digital Courses" sx={{display: 'flex',
                  alignItems: 'flex-start',
                  my:2,
                  justifyContent: 'flex-start',  
                  cursor:'pointer' ,
                  fontWeight: 400,  "& span": {  // Target the span element
                    fontFamily: theme=> theme.typography.smallText, // Change the font family of the span
                  },}}/>
                   <ListItemText onClick={()=> navigate('/product/favourite')} primary="P2P Product " sx={{display: 'flex',
                  alignItems: 'flex-start',
                  my:2,
                  justifyContent: 'flex-start',  
                  cursor:'pointer' ,
                  fontWeight: 400,  "& span": {  // Target the span element
                    fontFamily: theme=> theme.typography.smallText, // Change the font family of the span
                  },}}/>
              </AccordionDetails>
            </Accordion>

            </ListItem>

            <ListItem 
  sx={{ 
    width: '100%', 
    py: 0, 
    borderBottom: '1px solid #E6D9FE', 
    fontFamily: theme => theme.typography.smallText, 
    fontWeight: 400, 
    cursor: 'pointer', 
    px: 3,
    display: 'block'  // Ensures full width 
  }}
>
  <Accordion sx={{ boxShadow: 'none', width: '100%' }}>
    <AccordionSummary 
      sx={{ 
        p: 0, 
        borderBottom: '1px solid #E6D9FE', 
        width: '100%',
        display: 'flex' // Ensures children stretch properly
      }}
    > 
      Order History
    </AccordionSummary>

    <AccordionDetails sx={{ p: 0, width: '100%' }}>
      <ListItemText
          onClick={() => navigate('/product/giftshop/order-history')}
        primary="Gifts History"
        sx={{
          display: 'flex',
          alignItems: 'flex-start',
          width: '100%',
          my: 2,
          justifyContent: 'flex-start',
          cursor: 'pointer',
          fontWeight: 400,
          "& span": {
            fontFamily: theme => theme.typography.smallText,
          },
        }}
      />
      <ListItemText
        onClick={() => navigate('/product/digital-courses/order-history')}
        primary="Courses History"
        sx={{
          display: 'flex',
          alignItems: 'flex-start',
          width: '100%',
          my: 2,
          justifyContent: 'flex-start',
          cursor: 'pointer',
          fontWeight: 400,
          "& span": {
            fontFamily: theme => theme.typography.smallText,
          },
        }}
      />
    </AccordionDetails>
  </Accordion>
</ListItem>


            {/* {pathname.includes('digital-courses')?   //checks if the link is for digital courses then it doesn't show track order link
            <></>:
            // <ListItem button onClick={() => navigate('/product/track-order')
            //   } 
            // sx={{width:'100%',cursor:'pointer',px: 3,   
           
            // }}>
            // <Box
            //     sx={{
            //       borderBottom: '1px solid #E6D9FE',
            //       display: 'flex',
            //       alignItems: 'flex-start',
            //       fontFamily: theme=> theme.typography.smallText,
            //       fontWeight: 400,
            //       justifyContent: 'flex-start',
            //       width:'100%',
            //     }}
            //   >
            //        <ListItemText onClick={handleTrackingClick} primary="Track Gift Order" sx={{display: 'flex',
            //       alignItems: 'flex-start',
            //       justifyContent: 'flex-start',   
            //       fontWeight: 400,  "& span": {  // Target the span element
            //         fontFamily: theme=> theme.typography.smallText, // Change the font family of the span
            //       },}}/>
            //   </Box>
            //   {trackingSidebar && <TrackingSidebar onClose={handleCloseTrackingSidebar} state={trackingSidebar}/>}
            // </ListItem>
              } */}



<ListItem button  onClick={() => toggleDrawer(false)} sx={{width:'100%', cursor:'pointer', px: 3, 
           
          }}>
    <Box
        sx={{
          borderBottom: '1px solid #E6D9FE',
          display: 'flex',
          alignItems: 'flex-start',
          justifyContent: 'flex-start',
          width:'100%',
      
        }}

      >
        <a 
href="https://mydarads.com/dashboard/Mytransactions" 
target="_blank" 
rel="noopener noreferrer" 
style={{ width: '100%', textDecoration: 'none', color: 'inherit' }}
>
        <ListItemText primary="My Transactions" sx={{display: 'flex',
          alignItems: 'flex-start',
          justifyContent: 'flex-start',   
          fontWeight: 400,  "& span": {  // Target the span element
            fontFamily: theme=> theme.typography.smallText, // Change the font family of the span
          },}}/>
           </a>
      </Box>
  
    </ListItem>
            <ListItem button onClick={() => toggleDrawer(false)}sx={{cursor:'pointer',px: 3,
           
                  }}>
              <Box sx={{
                borderBottom: '1px solid #E6D9FE',
                display: 'flex',
                alignItems: 'flex-start',
                justifyContent: 'flex-start',
               
            
              }}>
            <NavLink
              to="https://mydarads.com/dashboard/makeorder "
              >
                   <ListItemText primary="My Dashboard" sx={{display: 'flex',
                  alignItems: 'flex-start',
                  justifyContent: 'flex-start', 
                  width:'100%',  
                  fontWeight: 400,  "& span": {  // Target the span element
                    fontFamily: theme=> theme.typography.smallText, // Change the font family of the span
                  },}}
                  />
              </NavLink>
            </Box>
            </ListItem>
          

          
            <ListItem
  button
  sx={{
    width: "fit-content", 
    maxWidth: "250px", 
    display: "flex",
    justifyContent: "center",
    cursor: "pointer",
    border: "1px solid rgba(0, 0, 0, 0.12)",
    backgroundColor: (theme) => theme.palette.grey[100], 
    margin: "auto", 
    padding: "12px 24px", 
    marginTop:"10px",
    borderRadius: "8px", 
    
  }}
  onClick={() => {
    handleLogout();
  }}
>
  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
    Logout
    <LogoutIcon fontSize="small" />
  </Box>
</ListItem>
          </List>
        </Drawer>
      </Box>

      {/* Desktop Links and Dropdown */}
      <Box
        sx={{
          display: { xs: 'none', md: 'flex' },
          alignItems: 'center',
          gap: 6,
        }}
      >
        {/* Home Link */}
        <Box 
        sx={{ 
          marginRight: '20px',
          color: 'rgba(85, 85, 86, 1)',
          paddingBottom: '5px',
      
        }}>
        <NavLink
          to="https://mydarads.com/dashboard/makeorder "
          style={{textDecoration:'none' ,color:'rgba(85, 85, 86, 1)',}}
        >
          Home
        </NavLink>
        </Box>

        {/* Product Dropdown */}
        <div style={{position:'relative'}}>
      <Button
        onClick={handleClick}
        endIcon={<KeyboardArrowDownIcon />}
        sx={{
        textDecoration: 'none',
        color: 'rgba(86, 4, 246, 1)',
        borderBottom: '2px solid blue', // Active border
        paddingBottom: '5px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor:'transparent',
        borderRadius:'0px',
        textTransform:'unset',
        px:0
        }}
      >
        Product
      </Button>
      <Menu
      anchorEl={anchorEl}
      open={open}
      onClose={handleClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
      sx={{top:10, borderRadius:'8px'}}
      >
            <Box
                sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexDirection: 'column',
                padding: 2,
                gap: 2,
                }}
            >
                <Link
                to={`/product/giftshop`}
                style={{
                    width: '100%',
                }}
                >
                <Box
                    sx={{
                    borderBottom: '1px solid #E6D9FE',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                   
                    }}
                >
                    <MenuItem onClick={handleClose}
                    >
                    Gift Shop
                    </MenuItem>
                </Box>
                </Link>

                <Link
                to={`product/digital-courses`}
                style={{
                    width: '100%',
                }}
                >
                <Box
                    sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  
                    }}
                >
                    <MenuItem onClick={handleClose} >
                    Digital Courses
                    </MenuItem>
                </Box>
                </Link>

              
                <Link
                to={`/product/ptwop`}
                style={{
                    width: '100%',
                }}
                >
                <Box
                    sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
             
                    }}
                >
                    <MenuItem onClick={handleClose} 
                  
                    >
                My P2P Products
                    </MenuItem>
                </Box>
                </Link>
                <Link
                to={`/product/marketplace`}
                style={{
                    width: '100%',
                }}
                >
                <Box
                    sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                   
                    }}
                >
                    <MenuItem onClick={handleClose} >
                    P2P Market Place
                    </MenuItem>
                </Box>
                </Link>
            </Box>
      </Menu>
    </div>

      {/* Right Side - Avatar and Cart */}
      <Box sx={{ display: { xs: 'none', md: 'flex' }, alignItems: 'center' }}>
        {/* Cart with Badge */}
       

 
     
      {/* Avatar with Dropdown */}
      <IconButton
          onClick={(e)=>handleMenuOpen('avatar', e)}
          sx={{
            color: 'inherit',
            
           
            position: 'relative',
            px:6,
                  }}
        >
          <Avatar>
            <img src={Avater} alt="Avatar" style={{ width: '100%', height: '100%' }} />
          </Avatar>
          {/* Caret Down Icon */}
          <Box
            position="absolute"
            sx={{
              width: 20,
              height: 20,
              
              bottom: 0,
              right: 0,
              top: '30px',
              backgroundColor: (theme) => theme.palette.primary.main,
              borderRadius:'50%',
              display:'flex',
              alignItems:'center',
              justifyContent:'center'
      
            }}
          >
            <img src={CaretDown} alt="Caret Down" style={{ width: '100%', height: '100%' }} />
          </Box>
        </IconButton>

        {/* Avatar Dropdown Menu */}
        <Drawer
          anchor="top"
          open={Boolean(menuState.avatar)}
          onClose={()=>handleMenuClose('avatar')}
          sx={{
            width: 250,
          
            flexShrink: 0,
            '& .MuiDrawer-paper': {
              width: 250,
              zIndex: 1203,
              color: '#000',
              height: 'auto',
             borderRadius:'10px',
              position: 'relative', // Position it absolutely
              top: '20px', // Adjust this based on where you want it in relation to the avatar
              left: 1030,
              right: -20,
            
              
            },
          }}
        >
          <List>
     

<ListItem 
  button 
  sx={{
    width: '100%', 
    display: 'flex', 
    justifyContent: 'center', 
    cursor: 'pointer',
    borderBottom: '1px solid rgba(0, 0, 0, 0.12)', // Added border bottom
    padding: '12px', // Added padding inside
   
  }} 
  onClick={() => {
    handleMenuClose('avatar');
    
  }}
>

<ListItemText onClick={()=> navigate('/product/giftshop')}
    primary="Gift Shop" 
    sx={{
      textAlign: 'center', 
      fontWeight: 400,
      fontFamily: theme => theme.typography.smallText,
    }} 
  />
</ListItem>  


<ListItem 
  button 
  sx={{
    width: '100%', 
    display: 'flex', 
    justifyContent: 'center', 
    cursor: 'pointer',
    borderBottom: '1px solid rgba(0, 0, 0, 0.12)', // Added border bottom
    padding: '12px', // Added padding inside
   
  }} 
  onClick={() => {
    handleMenuClose('avatar');
    
  }}
>

<ListItemText onClick={()=> navigate('/product/digital-courses')}
    primary="Digital Courses" 
    sx={{
      textAlign: 'center', 
      fontWeight: 400,
      fontFamily: theme => theme.typography.smallText,
    }} 
  />
</ListItem>   


<ListItem 
  button 
  sx={{
    width: '100%', 
    display: 'flex', 
    justifyContent: 'center', 
    cursor: 'pointer',
    borderBottom: '1px solid rgba(0, 0, 0, 0.12)', // Added border bottom
    padding: '12px', // Added padding inside
   
  }} 
  onClick={() => {
    handleMenuClose('avatar');
    
  }}
>
<ListItemText onClick={()=> navigate('/product/marketplace')}
    primary="P2P MarketPlace" 
    sx={{
      textAlign: 'center', 
      fontWeight: 400,
      fontFamily: theme => theme.typography.smallText,
    }} 
  />
</ListItem>

<ListItem 
  button 
  sx={{
    width: '100%', 
    display: 'flex', 
    justifyContent: 'center', 
    cursor: 'pointer',
    borderBottom: '1px solid rgba(0, 0, 0, 0.12)', // Added border bottom
    padding: '12px', // Added padding inside
   
  }} 
  onClick={() => {
    handleMenuClose('avatar');
    
  }}
>

<ListItemText onClick={()=> navigate('/product/ptwop')}
    primary="My P2P Product" 
    sx={{
      textAlign: 'center', 
      fontWeight: 400,
      fontFamily: theme => theme.typography.smallText,
    }} 
  />
</ListItem>    
     

<ListItem button sx={{width:'100%', display:'flex', justifyContent:'center', cursor:'pointer', 
           
          }}>
    <Accordion sx={{ boxShadow: 'none', py: 0, borderBottom: '1px solid rgba(0, 0, 0, 0.12)' }}>
      <AccordionSummary sx={{p:0, textAlign:'center',
            borderRadius: '8px',
            '.css-7iurs7-MuiAccordionSummary-content':{
              display:'flex',
              justifyContent:'center',
              m:0
            },
            '.css-m0wust-MuiButtonBase-root-MuiAccordionSummary-root':{
              minHeight:'0',                    
            },
            justifyContent:'center', fontFamily: theme=> theme.typography.smallText,
         }}>My Favourite</AccordionSummary>
      <AccordionDetails sx={{p:0}}>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', textAlign:'center', width:'100%'}}>
          <ListItemText  onClick={()=>{
            handleMenuClose('avatar')
            navigate('/product/giftshop/favourite')
          }} primary="Gifts" sx={{display: 'flex',
            borderRadius: '8px',
          alignItems: 'center',
          textAlign:'center',
          px:2,
          p:1,
         
          justifyContent: 'center',   
          fontWeight: 400,  "& span": {  // Target the span element
            fontFamily: theme=> theme.typography.smallText, // Change the font family of the span
          },}}/>
        </Box>
        <Box sx={{display: 'flex', alignItems: 'center', justifyContent: 'center',width:'100%'}}>
          <ListItemText  onClick={()=>{
            handleMenuClose('avatar')
            navigate('/product/digital-courses/favourite')
          }} primary="Digital Courses" sx={{display: 'flex',
            borderRadius: '8px',
          alignItems: 'center',
          textAlign:'center',
          px:2,
          py:1,
         
          justifyContent: 'center',   
          fontWeight: 400,  "& span": {  // Target the span element
            fontFamily: theme=> theme.typography.smallText, // Change the font family of the span
          },}}/>
        </Box>
        <Box sx={{display: 'flex', alignItems: 'center', justifyContent: 'center',width:'100%'}}>
          <ListItemText  onClick={()=>{
            handleMenuClose('avatar')
            navigate('/product/favourite')
          }} primary="P2P Product" sx={{display: 'flex',
            borderRadius: '8px',
          alignItems: 'center',
          textAlign:'center',
          px:2,
          py:1,
        
          justifyContent: 'center',   
          fontWeight: 400,  "& span": {  
            fontFamily: theme=> theme.typography.smallText, 
          },}}/>
        </Box>
      </AccordionDetails>
    </Accordion>

    </ListItem>

            
            <ListItem button sx={{width:'100%', display:'flex', justifyContent:'center', cursor:'pointer',  
          
                  }}>
 <Accordion sx={{ boxShadow: 'none', py: 0, borderBottom: '1px solid rgba(0, 0, 0, 0.12)' }}>
              <AccordionSummary sx={{p:0, textAlign:'center',
                    borderRadius: '8px',
                    '.css-7iurs7-MuiAccordionSummary-content':{
                      display:'flex',
                      justifyContent:'center',
                      m:0
                    },
                    '.css-m0wust-MuiButtonBase-root-MuiAccordionSummary-root':{
                      minHeight:'0',                    
                    },
                    justifyContent:'center', fontFamily: theme=> theme.typography.smallText
                   }}>Order History</AccordionSummary>
              <AccordionDetails sx={{p:0}}>
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', textAlign:'center', width:'100%'}}>
                  <ListItemText  onClick={()=>{
                    handleMenuClose('avatar')
                    navigate('/product/giftshop/order-history')
                  }} primary="Gifts History" sx={{display: 'flex',
                    borderRadius: '8px',
                  alignItems: 'center',
                  textAlign:'center',
                  px:2,
                  p:1,
                 
                  justifyContent: 'center',   
                  fontWeight: 400,  "& span": {  
                    fontFamily: theme=> theme.typography.smallText, 
                  },}}/>
                </Box>
                <Box sx={{display: 'flex', alignItems: 'center', justifyContent: 'center',width:'100%'}}>
                  <ListItemText  onClick={()=>{
                    handleMenuClose('avatar')
                    navigate('/product/digital-courses/order-history')
                  }} primary="Courses History" sx={{display: 'flex',
                    borderRadius: '8px',
                  alignItems: 'center',
                  textAlign:'center',
                  px:2,
                  py:1,
                 
                  justifyContent: 'center',   
                  fontWeight: 400,  "& span": {  // Target the span element
                    fontFamily: theme=> theme.typography.smallText, // Change the font family of the span
                  },}}/>
                </Box>
              </AccordionDetails>
            </Accordion>

            </ListItem>
            {/* {pathname.includes('digital-courses')?   //checks if the link is for digital courses then it doesn't show track order link
            <></>:
            <ListItem button onClick={
              handleTrackingClick
            } sx={{width:'100%',cursor:'pointer', 
             }}>
            <Box
                sx={{
                  borderBottom: '1px solid #E6D9FE',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  width:'100%',
                
                }}
              >


              
                   <ListItemText onClick={
                    handleTrackingClick
                  } primary="Track Gift Order" sx={{display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',   
                  fontWeight: 400,  "& span": {  // Target the span element
                    fontFamily: theme=> theme.typography.smallText, // Change the font family of the span
                  },}}/>
              </Box>
            </ListItem>
              } */}

<ListItem 
  button 
  sx={{
    width: '100%', 
    display: 'flex', 
    justifyContent: 'center', 
    cursor: 'pointer',
    borderBottom: '1px solid rgba(0, 0, 0, 0.12)', 
    padding: '12px', 

  }} 
  onClick={() => {
    handleMenuClose('avatar');
    
  }}
>

<ListItemText 
  onClick={() => window.location.href = 'https://mydarads.com/dashboard/Mytransactions'}
  primary="My Transactions" 
  sx={{
    textAlign: 'center', 
    fontWeight: 400,
    fontFamily: theme => theme.typography.smallText,
  }} 
/>

</ListItem>  


            <ListItem button onClick={()=>handleMenuClose('avatar')} sx={{width:'100%',cursor:'pointer', 
           
                  }}>
            <Box sx={{
                  borderBottom: '1px solid #E6D9FE',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  width:'100%',
                
                }}>
            <NavLink
                to="https://mydarads.com/dashboard/makeorder "
              >
                   <ListItemText primary="My Dashboard" sx={{display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',   
                  fontWeight: 400,  "& span": {  // Target the span element
                    fontFamily: theme=> theme.typography.smallText, // Change the font family of the span
                  },}}/>
              </NavLink>
                </Box>
            </ListItem>
            
           

 







<ListItem
  button
  sx={{
    width: "fit-content", 
    maxWidth: "250px", 
    display: "flex",
    justifyContent: "center",
    cursor: "pointer",
    border: "1px solid rgba(0, 0, 0, 0.12)",
    backgroundColor: (theme) => theme.palette.grey[100], 
    margin: "auto", 
    padding: "12px 24px", 
    marginTop:"10px",
    borderRadius: "8px", 
   
  }}
  onClick={() => {
    handleLogout();
  }}
>
  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
    Logout
    <LogoutIcon fontSize="small" />
  </Box>
</ListItem>



          </List>
        </Drawer>
        {balance !== null && (
  <Typography
    variant="body2"
    sx={{
      mt: 3, 
      ml: 2,
      fontSize:20,
      fontWeight: 800,
      color: (theme) => theme.palette.primary.main,
      fontFamily: (theme) => theme.typography.smallText,
    }}
  >
    NGN {balance.toLocaleString(undefined, { minimumFractionDigits: 2 })}
  </Typography>
)}

      </Box>
      {trackingSidebar && <TrackingSidebar onClose={handleCloseTrackingSidebar} state={trackingSidebar}/>}
      </Box>
  </Box>
    
  )
}
